import React from 'react';
import { css } from 'aphrodite';

import styles from './styles';

export default ({ children }) => (
  <div className={css(styles.sidebar)}>{children}</div>
);
